import Image from 'app/Components/Shared/Image/image';
import React, { useEffect } from 'react';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import { Container, Row, Col } from 'reactstrap';
import { changeHandler, validateHandler, keyUpHandler, clearCode, addAttempt, setVerifyCode, reportAnalytics } from './OTPVerifyCodeSlice';
import { setOtpTicketId } from '../saleBlockSlice';
import { connect } from 'react-redux';
import { showAppLoader, hideAppLoader } from '../../../Shared/Loader/LoaderSlice';
import ProviderManager from './../../../../provider/providerManager';
import Config from '../../../../Config';
import OtpInput from 'react-otp-input';
import { color } from 'd3';
import { getRecaptchaToken } from '../../../../utilities/recaptcha/recaptcha';

const otpVerifyCode = (props) => {
  const handleChange = (otp) => {
    props.setVerifyCode({ verifyCode: otp });
  };

  useEffect(() => {
    if ('OTPCredential' in window) {
      async function fetchOtp() {
        try {
          const otp = await navigator.credentials.get({
            otp: { transport: ['sms'] },
          });
          if (otp?.code) {
            handleChange(otp.code);
          }
        } catch (err) {
          console.error('Error fetching OTP:', err);
        }
      }
      fetchOtp();
    }
  }, []);

  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
        if (props.onSubmit && props.onSubmit == true) {
          props.validateHandler(props.form);
        }
      }
    },
    [props.onSubmit]
  );

  useExtendedEffect((runSideEffects) => {
    if (runSideEffects()) {
      if (props.form.valid === true && props.onSubmit == true) {
        handleChange('clear');
        props.clearCode({ verifyCode: '' });
        props.onValid(props.form.valid);
      }
    }
  });

  useExtendedEffect((runSideEffects) => {
    if (runSideEffects()) {
      const header = document.querySelector('.cellcom-header');
      const topTitle = document.querySelector('.top-title');

      if (window.innerHeight < 400) {
        topTitle.style.display = 'none';
        header.style.display = 'none';
      } else {
        topTitle.style.display = 'block';
        header.style.display = 'block';
      }
    }
  }, []);

  const readyToCreateOtp = () => {
    switch (props.saleType) {
      case 'tv':
        props.reportAnalytics({
          eventCategory: 'tv_newsale_process',
          eventAction: 'click_30',
          eventLabel: props.productsInfo.selectedProducts[0]?.name,
        });
        break;
      case 'app':
        props.reportAnalytics({
          eventCategory: 'app_newsale_process',
          eventAction: 'click_40',
          eventLabel: props.productsInfo.selectedProducts[0]?.name,
        });
        break;
      case 'cellular':
        props.reportAnalytics({
          eventCategory: 'cellular_newsale_process',
          eventAction: 'click_46',
          eventLabel: 'button_13',
        });
        break;
      case 'internet':
        props.reportAnalytics({
          eventCategory: 'fiber_newsale_process',
          eventAction: 'click_22',
          eventLabel: props.productsInfo.selectedProducts[0]?.name,
        });
        break;
    }
    if (props.form.numOfAttempts >= Config.verifyCodeAttemptsLimit) return;

    if (props.otpPhoneData.phone != null && props.otpPhoneData.phone != undefined) {
      props.showAppLoader();
      createOtp(false);
    }
  };

  const readyToCreateVoiceOtp = () => {
    if (props.form.numOfAttempts >= Config.verifyCodeAttemptsLimit) return;

    if (props.otpPhoneData.phone != null && props.otpPhoneData.phone != undefined) {
      props.showAppLoader();
      createOtp(true);
    }
  };

  const createOtp = async (isVoice) => {
    const captchaToken = await getRecaptchaToken('OtpVerifyPhonePage');
    if (captchaToken == undefined || captchaToken == null || captchaToken == '') {
      return;
    }

    try {
      const result = await ProviderManager.getProviderData('createOtp', [props.otpPhoneData.phone, isVoice, captchaToken]);
      if (result.Body && result.Body.step1Ticket) {
        props.setOtpTicketId({ otpTicketId: result.Body.step1Ticket });
        handleChange('clear');
        props.clearCode({ verifyCode: '' });
      }
    } catch (error) {
      console.info('createOtp', error);
      return null;
    } finally {
      props.hideAppLoader();
      props.addAttempt(props.form);
    }
  };

  const selectNumber = (e) => {
    if (e.target == undefined || e.target.value.length == 0) return;

    const [fieldName, fieldIndex] = e.target.name.split('-');

    const input = document.querySelector(`input[name=input-${parseInt(fieldIndex, 10)}]`);

    if (input !== null) {
      input.select();
      input.readOnly = false;
    }
  };

  return (
    <div className='container-fluid main'>
      <div className='otp-verify-code'>
        <Row>
          <Col ms={12}>
            <h1 className='main-title'>{props.title}</h1>
          </Col>
        </Row>
        <Row>
          <Col ms={12}>
            <h1 className='top-title'>{props.subTitle}</h1>
          </Col>
        </Row>
        <Row>
          <Col ms={12}>
            <div className='component-container' style={{ backgroundColor: 'transparent' }}>
              <div className='mainDiv'>
                <OtpInput
                  shouldAutoFocus={true}
                  value={props.form.verifyCode}
                  onChange={handleChange}
                  numInputs={6}
                  isInputNum={true}
                  separator={<span className='inputSeparator'></span>}
                  inputStyle={`input-design`}
                  containerStyle={`mainDivInside`}
                  name="otp"
                  renderInput={(inputProps, index) => (
                    <input {...inputProps} key={index} autoComplete="one-time-code" />
                  )}
                />
              </div>

              {props.wrongOtpMessage != ''}
              <br />
              <div className='error-container'>
                <div className='error'>{props.wrongOtpMessage}</div>
              </div>

              {props.form.numOfAttempts >= Config.verifyCodeAttemptsLimit ? <div className='error'>לא ניתן לבצע ניסיונות נוספים</div> : ''}

              <section className='otp-btn-container'>
                <div role='button' tabIndex='0' onClick={readyToCreateOtp}>
                  <section className='otp-btn-container'>
                    <div>
                      <Image src={require('./images/sms.svg')} alt='לא קיבלתי קוד, שילחו לי שוב' />
                    </div>
                    <div>
                      <span>
                        הקוד לא הגיע, <br />
                        שלחו לי שוב
                      </span>
                    </div>
                  </section>
                </div>
                <div className='spacer'></div>
                <div role='button' tabIndex='1' onClick={readyToCreateVoiceOtp}>
                  <section className='otp-btn-container'>
                    <div>
                      <Image src={require('./images/voice.svg')} alt='שילחו לי קוד בהודעה קולית' />
                    </div>
                    <div>
                      <span>
                        שילחו לי קוד
                        <br />
                        בהודעה קולית
                      </span>
                    </div>
                  </section>
                </div>
              </section>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    form: state.otpVerifyCode.form,
    otpPhoneData: state.otpVerifyPhone.form,
    saleType: state.saleBlock.saleType,
    productsInfo: state.saleBlock.productsInfo,
  };
};

const mapDispatchToProps = {
  changeHandler,
  validateHandler,
  keyUpHandler,
  setOtpTicketId,
  clearCode,
  showAppLoader,
  hideAppLoader,
  addAttempt,
  setVerifyCode,
  reportAnalytics,
};

export default connect(mapStateToProps, mapDispatchToProps)(otpVerifyCode);
